import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';

const Skills = ({ staggerContainer, staggerItem }) => {
  return (
    <section id="skills" className="py-20 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 transition-colors duration-300">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-16">
          <span className="underline-3d">Zručnosti</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {portfolioData.skills.map((category, index) => (
            <motion.div 
              key={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={staggerContainer}
              className="bg-gray-50 dark:bg-gray-800/50 p-8 rounded-3xl border border-gray-200 dark:border-gray-700/50 shadow-xl hover:border-blue-600/30 transition-all duration-300 h-full backdrop-blur-sm"
            >
              <h3 className="text-2xl font-bold text-blue-600 mb-8">{category.title}</h3>
              <div className="grid grid-cols-2 gap-6">
                {category.skills.map((skill, si) => (
                  <motion.div 
                    key={si}
                    variants={staggerItem}
                    whileHover={{ scale: 1.05 }}
                    className="flex flex-col items-center group"
                  >
                    <div className="w-14 h-14 bg-gray-100 dark:bg-gray-700/50 rounded-2xl flex items-center justify-center mb-3 group-hover:bg-blue-600 group-hover:shadow-[0_0_15px_rgba(37,99,235,0.4)] transition-all duration-300 border border-gray-200 dark:border-gray-600">
                      <Icon icon={skill.icon} className="text-3xl" style={{ color: skill.color }} />
                    </div>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300 group-hover:text-blue-600 transition-colors uppercase tracking-wider">{skill.name}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
